import { Button, Card } from '@toggle/design-system';
import clsx from 'clsx';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/query-params';
import { useAuth } from '~/stores/use-auth/useAuth';
import { useUser } from '~/stores/use-user/useUser';

import authStyles from '../auth-shared-styles/AuthSharedStyles.module.scss';
import { OnHoldActionButton } from '../on-hold-action-button/onHoldActionButton';
import {
  copyRecord,
  getDescriptionType,
  getTitleType,
  PageVariants,
} from '../utils';
import styles from './OnHold.module.scss';

const contactFormLink = 'https://support.reflexivity.com/hc/en-us/requests/new';

export const OnHold = () => {
  const { t } = useTranslation('auth');
  const { logout, unLockAccount } = useAuth();
  const { params } = useQueryParams();

  const isProfessional = useUser(state => state.user?.is_professional);

  const copyReference = copyRecord(t);

  const reason = params[queryKeys.reason];

  const handleSignOut = () => {
    unLockAccount();
    logout(true);
  };

  const subscriptionType = isProfessional
    ? PageVariants.Pro
    : PageVariants.Basic;

  const titleType = getTitleType({
    reason,
    subscriptionType,
  }) as keyof typeof copyReference.title;

  const descriptionType = getDescriptionType({
    reason,
    subscriptionType,
  }) as keyof typeof copyReference.description;

  return (
    <div
      className={clsx(authStyles.layout, styles.wrapper)}
      style={{ backgroundImage: `url('/app/static/images/auth/sun.png')` }}
    >
      <div>
        <Card className={styles.styledCard}>
          <img
            className={styles.lockIcon}
            src="/app/static/images/auth/lock.svg"
            alt=""
          />
          <div className={styles.contentWrapper}>
            <h1 className={styles.title}>{copyReference.title[titleType]}</h1>
            <p className={styles.description}>
              {copyReference.description[descriptionType]}
            </p>
          </div>

          <div className={styles.buttonWrapper}>
            <OnHoldActionButton />
          </div>
          <Button
            data-testid="sign-out-btn"
            label={t('auth:onHold.signOut')}
            onClick={handleSignOut}
            variant="empty"
            size="small"
          />
        </Card>
        <div className={styles.contact}>
          <Trans
            t={t}
            i18nKey="auth:onHold.stillHavingTrouble"
            components={[<a key="key-0" href={contactFormLink} />]}
          />
        </div>
      </div>
    </div>
  );
};
